import {getApiProps} from "@/lib/lib";
// import {objectComparison} from "@/lib/lib";
const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed_at';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

export default {
    state: {
        xRoutesUsersLiteLoad: false,
        xRoutesUsersFullLoad: false,
        xRoutesUsers: [],
    },
    actions: {
        fetchXRoutesUsers/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchXRoutesUsers', args, time: Date.now() / 1000})

                const params = getApiProps('xRoutesUsers', args)
                this.$api.xroutesUsers.getAll({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchXRoutesUsers', args, inprogress: false})
                    });
            })
        },
        fetchXRoutesUsersAll({dispatch, commit}) {
            return new Promise((resolve, reject) => {
                this.$api.xroutesUsers.getAll()
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('setXRoutesUsers', response.data)
                            commit('setXRoutesUsersLiteLoad', true)
                            commit('setXRoutesUsersFullLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchXRoutesUsersAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        // fetchXRoutesUsersAllLite({dispatch, commit, getters}) {
        //     return new Promise((resolve, reject) => {
        //         if (getters.isXRoutesUsersLiteLoad) {
        //             return resolve(getters.getXRoutesUsers.length)
        //         }
        //         dispatch('fetchXRoutesUsers', {lite: true})
        //             .then((data) => {
        //                 commit('updateXRoutesUsers', data)
        //                 //commit('setXRoutesUsersLiteLoad', true)
        //                 resolve(data.length)
        //             })
        //             .catch((error) => {
        //                 reject(error)
        //                 console.error(error);
        //                 setTimeout(() => {
        //                     dispatch('fetchXRoutesUsersAllLite', {})
        //                 }, 60 * 1000)
        //             })
        //     })
        // },
        // fetchXRoutesUsersAllPages({dispatch, commit, getters}, args) {
        //     //dispatch('setLastCall', {name: 'fetchXRoutesUsersAll', args, time: Date.now() / 1000})
        //     dispatch('setLastCall', {name: 'fetchXRoutesUsersChanged', args, time: Date.now() / 1000})
        //
        //     return new Promise((resolve, reject) => {
        //             if (!getters.getApiToken) {
        //                 return reject(null)
        //             }
        //             if (!getters.getXRoutesUsers.length) {
        //                 return resolve([])
        //             }
        //             let pageSize = consts.querySettings.pageSize
        //             let pages = Math.ceil(getters.getXRoutesUsers.length / pageSize)
        //             let fetch = range(pages).map(i => {
        //                 let page = i + 1;
        //                 return dispatch('fetchXRoutesUsers', {page, 'page-size': pageSize, ...args})
        //                     .then((data) => {
        //                         commit('updateXRoutesUsers', data)
        //                     })
        //                     .catch(() => {
        //                         dispatch('fetchXRoutesUsers', {page, 'page-size': pageSize, ...args})
        //                     })
        //             });
        //             resolve(fetch)
        //         })
        //         .then((fetch) => {
        //             return Promise.all(fetch)
        //                 .finally(() => {
        //                     commit('setXRoutesUsersFullLoad', true)
        //                 })
        //         })
        //         .finally(() => {
        //             //dispatch('setLastCall', {name: 'fetchXRoutesUsersAll', args, inprogress: false})
        //             dispatch('setLastCall', {name: 'fetchXRoutesUsersChanged', args, inprogress: false})
        //         })
        // },
        // fetchXRoutesUsersChanged({dispatch, commit, getters}, args) {
        //     if (!getters.getApiToken || !getters.isXRoutesUsersFullLoad) {
        //         return Promise.resolve(null)
        //     }
        //     dispatch('setLastCall', {name: 'fetchXRoutesUsersChanged', args, time: Date.now() / 1000})
        //
        //     args = {...consts.querySettings.filter, ...args}
        //     return dispatch('fetchXRoutesUsers', args)
        //         .then((data) => {
        //             commit('updateXRoutesUsers', data)
        //             return dispatch('fetchXRoutesUsers', {fields: 'id', expand: ''})
        //         })
        //         .then((data) => {
        //             commit('filterXRoutesUsers', data)
        //         })
        //         .finally(() => {
        //             dispatch('setLastCall', {name: 'fetchXRoutesUsersChanged', args, inprogress: false})
        //         });
        // },
        reloadXRoutesUsersAll({commit, dispatch}, args) {
            commit('clearXRoutesUsers')
            return dispatch('fetchXRoutesUsersAll', args)
                // .then(() => {
                //     dispatch('fetchXRoutesUsersAllPages', args)
                // })
        },

        // fetchXRoutesUser({commit, getters}, args) {
        //     return new Promise((resolve, reject) => {
        //         if (!getters.getApiToken || !args.id) {
        //             return reject(false)
        //         }
        //         const params = getApiProps('xRoutesUsers', args)
        //         delete params.id;
        //         this.$api.xroutesUsers.find(args.id, params)
        //             .then((response) => {
        //                 if (response.status < 400 && !response.data?.error) {
        //                     commit('updateXRoutesUser', response.data)
        //                     resolve(true)
        //                 } else {
        //                     console.error(response);
        //                     reject(false)
        //                 }
        //             })
        //             .catch((error) => {
        //                 console.error(error);
        //                 reject(false)
        //             });
        //     });
        // },

        // saveXRoutesUser({dispatch}, xRoutesUser) {
        //     let fn = (xRoutesUser.id) ? 'updateXRoutesUser' : 'createXRoutesUser'
        //     return dispatch(fn, xRoutesUser);
        // },
        // createXRoutesUser({commit, dispatch}, xRoutesUser) {
        //     return new Promise((resolve, reject) => {
        //         const params = getApiProps('xRoutesUsers')
        //         this.$api.xroutesUsers.create(xRoutesUser, params)
        //             .then((response) => {
        //                 if (response.status < 400 && !response.data?.error) {
        //                     commit('updateXRoutesUser', response.data)
        //                     dispatch('fetchXRoutesUsersChanged')
        //                 }
        //                 resolve(response)
        //             })
        //             .catch((error) => {
        //                 console.error(error);
        //                 reject(error)
        //             });
        //     })
        // },
        // updateXRoutesUser({commit, dispatch}, xRoutesUser) {
        //     return new Promise((resolve, reject) => {
        //         const params = getApiProps('xRoutesUsers')
        //         this.$api.xroutesUsers.update(xRoutesUser.id, xRoutesUser, params)
        //             .then((response) => {
        //                 if (response.status < 400 && !response.data?.error) {
        //                     commit('updateXRoutesUser', response.data)
        //                     dispatch('fetchXRoutesUsersChanged')
        //                 }
        //                 resolve(response)
        //             })
        //             .catch((error) => {
        //                 console.error(error);
        //                 reject(error)
        //             });
        //     })
        // },
        //
        // deleteXRoutesUser({commit, dispatch}, id) {//remove
        //     return new Promise((resolve, reject) => {
        //         const params = getApiProps('xRoutesUsers')
        //         this.$api.xroutesUsers.delete(id, {...params, ...with_removed})//remove
        //             .then((response) => {
        //                 if (response.status < 400 && (!response.data || !response.data?.error)) {
        //                     if (!response.data) commit('deleteXRoutesUser', id)
        //                     else commit('updateXRoutesUser', response.data)
        //                     dispatch('fetchXRoutesUsersChanged')
        //                 }
        //                 resolve(response)
        //             })
        //             .catch((error) => {
        //                 console.error(error);
        //                 reject(error)
        //             });
        //     })
        // },
        // restoreXRoutesUser({commit, dispatch}, id) {
        //     return new Promise((resolve, reject) => {
        //         const params = getApiProps('xRoutesUsers')
        //         this.$api.xroutesUsers.restore(id, {...params, ...with_removed})
        //             .then((response) => {
        //                 if (response.status < 400 && !response.data?.error) {
        //                     commit('updateXRoutesUser', response.data)
        //                     dispatch('fetchXRoutesUsersChanged')
        //                 }
        //                 resolve(response)
        //             })
        //             .catch((error) => {
        //                 console.error(error);
        //                 reject(error)
        //             });
        //     })
        // },
        // deleteXRoutesUserPermanently({commit, dispatch}, id) {
        //     return new Promise((resolve, reject) => {
        //         const params = getApiProps('xRoutesUsers')
        //         this.$api.xroutesUsers.deletePermanently(id, {...params, ...with_removed})
        //             .then((response) => {
        //                 if (response.status < 400 && (!response.data || !response.data?.error)) {
        //                     commit('deleteXRoutesUser', id)
        //                     dispatch('fetchXRoutesUsersChanged')
        //                 }
        //                 resolve(response)
        //             })
        //             .catch((error) => {
        //                 console.error(error);
        //                 reject(error)
        //             });
        //     })
        // },

        //sayHello() {}
    },
    mutations: {
        setXRoutesUsersLiteLoad(state, LiteLoad) {
            state.xRoutesUsersLiteLoad = state.xRoutesUsersLiteLoad || LiteLoad
        },
        setXRoutesUsersFullLoad(state, FullLoad) {
            state.xRoutesUsersFullLoad = state.xRoutesUsersFullLoad || FullLoad
        },

        setXRoutesUsers(state, nXRoutesUsers) {
            nXRoutesUsers = nXRoutesUsers.map(u => {
                //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                return Object.freeze(u)
            })
            nXRoutesUsers.sort(sortByName)
            state.xRoutesUsers = nXRoutesUsers
        },

        updateXRoutesUsers(state, nXRoutesUsers) {
            if (!state.xRoutesUsers.length) {
                nXRoutesUsers = nXRoutesUsers.map(u => {
                    //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return Object.freeze(u)
                })
                nXRoutesUsers.sort(sortByName)
                state.xRoutesUsers = nXRoutesUsers
                return true
            }

            // console.log('updateXRoutesUsers', state.xRoutesUsers.length)
            nXRoutesUsers.forEach(function (nXRoutesUser) {
                let i = state.xRoutesUsers.findIndex(u => (u.id == nXRoutesUser.id))
                if (i < 0) {
                    state.xRoutesUsers.push(Object.freeze(nXRoutesUser))
                } else
                if (state.xRoutesUsers[i][changedField] != nXRoutesUser[changedField]) {
                    // updateObjectByDiff(state.xRoutesUsers[i], nXRoutesUser)
                    delete nXRoutesUser.id
                    state.xRoutesUsers[i] = Object.freeze({...state.xRoutesUsers[i], ...nXRoutesUser})
                }
            })
        },
        filterXRoutesUsers(state, nXRoutesUsers) {
            // let Ids = state.xRoutesUsers.map(u=> u.id)
            let nIds = nXRoutesUsers.map(u => u.id)
            let removedIds = state.xRoutesUsers.filter(u => !nIds.includes(u.id)).map(u => u.id)
            removedIds.forEach(removedId => {
                let i = state.xRoutesUsers.findIndex(u => (u.id == removedId))
                if (i != -1) {
                    state.xRoutesUsers.splice(i, 1)
                }
            })
        },
        updateXRoutesUser(state, nXRoutesUser) {
            let i = state.xRoutesUsers.findIndex(u => (u.id == nXRoutesUser.id))
            if (i < 0) {
                state.xRoutesUsers.push(Object.freeze(nXRoutesUser))
            } else
            if (state.xRoutesUsers[i][changedField] != nXRoutesUser[changedField]) {
                // updateObjectByDiff(state.xRoutesUsers[i], nXRoutesUser)
                let xRoutesUser = {...nXRoutesUser} //ToDo fix
                delete xRoutesUser.id
                state.xRoutesUsers[i] = Object.freeze({...state.xRoutesUsers[i], ...xRoutesUser})
            }
        },
        deleteXRoutesUser(state, id) {
            let i = state.xRoutesUsers.findIndex(u => (u.id == id))
            if (i != -1) {
                state.xRoutesUsers.splice(i, 1)
            }
        },
        clearXRoutesUsers(state) {
            state.xRoutesUsers = []
            state.xRoutesUsersLiteLoad = false
            state.xRoutesUsersFullLoad = false
        },
    },
    getters: {
        isXRoutesUsersLiteLoad(state) {
            return state.xRoutesUsersLiteLoad
        },
        isXRoutesUsersFullLoad(state) {
            return state.xRoutesUsersFullLoad
        },
        getXRoutesUsers(state) {
            return state.xRoutesUsers
        },
        getXRoutesUsersByIds(state) {
            return state.xRoutesUsers.reduce((xRoutesUsersByIds, u) => {
                xRoutesUsersByIds[u.system_user_id] = u
                return xRoutesUsersByIds
            }, {})
        },
    }
}
